import styled from 'styled-components';

export const Container = styled.div`
  ul {
    list-style: disc inside;
    padding-left: 1.5rem;
  }
`;
